export const AI_SPEND_CAP_CODE = 'AI_SPEND_CAP';

const SPEND_CAP_PATTERN =
  /spending cap|spend cap|exceeded your current quota|insufficient.?quota|billing.*limit|credit balance.*too low|budget.*exceeded/i;

export function isAiSpendCapError(err: { code?: string; message?: string } | null | undefined): boolean {
  if (!err) return false;
  if (err.code === AI_SPEND_CAP_CODE) return true;
  return SPEND_CAP_PATTERN.test(err.message || '');
}

export function getAiChatErrorPresentation(err: Error & { code?: string }) {
  if (isAiSpendCapError(err)) {
    return {
      label: 'Monthly AI spending cap reached',
      sublabel:
        'Ask an organisation admin to raise the limit at ai.studio/spend, switch to a lower-cost model in Organisation Settings → AI, or add a different provider API key.',
      showRetry: false,
      applyCooldown: false,
    };
  }

  return {
    label: err.message || 'Message failed to send',
    sublabel: undefined,
    showRetry: true,
    applyCooldown: ['AI_RATE_LIMIT', 'AI_DUPLICATE', 'AI_TIMEOUT'].includes(err.code || ''),
  };
}
